import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

const FiatPgResponse = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { path } = useParams();

  useEffect(() => {
    const pathSegments = location.pathname.split("/");
    const currency = pathSegments.length >= 4 ? pathSegments[2] : "";
    navigate(`/wallet/deposits/`, { replace: true });
  }, [location.pathname, navigate, path, dispatch]);

  return (
    <div
      className="text-center mt-5 fiat-pg-response"
      style={{
        fontSize: "1.5rem",
        fontWeight: "bold",
      }}
    >
      Redirecting...
    </div>
  );
};

export default FiatPgResponse;
